import React, { createContext, useContext, useReducer, useEffect, useState } from 'react';
import { firestore } from 'config/firebase';
import { collection, getDocs } from 'firebase/firestore';

const ProductsContext = createContext();

const initialState = { products: [], };

const reducer = (state, { type, payload }) => {
    switch (type) {
        case "SET_PRODUCTS":
            return { ...state, products: payload.products };
        case "ADD_PRODUCT":
            return { ...state, products: [...state.products, payload.product] };
        case "UPDATE_PRODUCT":
            return {
                ...state, products: state.products.map(product => product.id === payload.product.id ? payload.product : product),
            };
        case "DELETE_PRODUCT":
            return { ...state, products: state.products.filter(product => product.id !== payload.id), };
        default:
            return state;
    }
};

export default function ProductsProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const [isProductsLoading, setIsProductsLoading] = useState(false)
    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            setIsProductsLoading(true)
            const querySnapshot = await getDocs(collection(firestore, "products"));
            const products = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            dispatch({ type: "SET_PRODUCTS", payload: { products } });
        } catch (error) {
            console.error("Error fetching products:", error);
        } finally {
            setIsProductsLoading(false)
        }
    };

    return (
        <ProductsContext.Provider value={{ ...state, fetchProducts, isProductsLoading }}>
            {children}
        </ProductsContext.Provider>
    );
}

export const useProductsContext = () => useContext(ProductsContext);